import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import PaginationTable from '../../PaginationTable';
import {formatDatetime, formatFloat, numberPadding } from '../../../../utils/formatting';


export default class AccompanimentCoordinator extends React.Component {

    constructor(props) {
        super(props);
        this.showDetail = this._showDetail.bind(this);
        this.hideDetail = this._hideDetail.bind(this);
        this.state = {
            showDetailFor : null
        }
    }

    _showDetail(report) {
        this.setState({
            showDetailFor : report,
        });
    }

    _hideDetail() {
        this.setState({
            showDetailFor : null,
        });
    }


    render() {
        const report = this.state.showDetailFor;
        return (
            <div className="table-responsive">
                <PaginationTable
                    territories={this.props.territories}
                    coordinations={this.props.coordinations}
                    {...this.props.data}
                    showDetail={this.showDetail}
                    pageChange={this.props.changePage}
                    headerComponent={renderHeader}
                    rowComponent={renderRow}/>

                <Modal isOpen={report !== null} toggle={this.hideDetail} bsSize="large">
                    <ModalHeader toggle={this.hideDetail}>
                        Detalle
                    </ModalHeader>
                    <ModalBody>
                        {
                            report !== null ?
                            <table className="table">
                                <tbody>
                                    <tr className="table-active">
                                        <th colSpan={3}>
                                            1. Principales clientes PyME
                                        </th>
                                    </tr>
                                    <tr className="table-active">
                                        <th colSpan={3}>
                                            <small>1.1 Cartera Crédito PyME</small>
                                        </th>
                                    </tr>
                                    <tr>
                                        <td>
                                            ¿Cuál es el estatus de cartera de crédito (real vs meta)
                                        </td>
                                        <td>
                                            {report.credito_cifras}
                                        </td>
                                        <td>
                                            {report.credito_comments}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            ¿Cúal es la estrategia para cubrir gaps?
                                        </td>
                                        <td colSpan={2}>
                                            {report.estrategia_gaps_cred}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            ¿Se requiere algún apoyo para alcanzar la meta?
                                        </td>
                                        <td colSpan={2}>
                                            {report.apoyo_alcanzar}
                                        </td>
                                    </tr>
                                    <tr className="table-active">
                                        <th colSpan={3}>
                                            <small>1.2 Captación de clientes PyME</small>
                                        </th>
                                    </tr>
                                    <tr>
                                        <td>
                                            ¿Cuál es el estatus del portafolio?
                                        </td>
                                        <td>
                                            {formatFloat(report.estatus_porta_ingreso)}
                                        </td>
                                        <td>
                                            {formatFloat(report.estatus_porta_salida)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            ¿Se tiene alguna estratégia para cerrar el gap?
                                        </td>
                                        <td colSpan={2}>
                                            {report.estrategia_porta_gap}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            ¿Se requiere algún apoyo para recuperar montos perdidos?
                                        </td>
                                        <td colSpan={2}>
                                            {report.apoyo_recuperar}
                                        </td>
                                    </tr>
                                    <tr className="table-active">
                                        <th colSpan={3}>
                                            2. Seguimiento de campaña de crédito
                                        </th>
                                    </tr>
                                    
                                    <tr>
                                        <td>
                                            ¿Cuál es el porcentaje de conversión de la campaña?
                                        </td>
                                        <td>
                                            {report.seg_cifras}
                                        </td>
                                        <td>
                                            {report.seg_comments}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            ¿Cúal es la estrategia para colocar el restante?
                                        </td>
                                        <td>
                                            {report.estrategia_gaps_seg}
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                            : null
                        }
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

function renderHeader(props) {
    return (
        <tr>
            <th>Fecha</th>
            <th>Título cita</th>
            <th>Número empleado</th>
            <th>Coordinador</th>
            <th>Detalle</th>
        </tr>
    );
}

function renderRow(props) {
    const {item} = props;
    return (
        <tr>
            <td>
                {formatDatetime(item.event.datetime)}
            </td>
            <td>
                {item.event.title}
            </td>
            <td>
                {numberPadding(item.event.target.emp_number, 6)}
            </td>
            <td>
                {item.event.target.name}
            </td>
            <td>
                <button className="btn btn-sm btn-primary" onClick={() => props.showDetail(item)}>Detalle</button>
            </td>
        </tr>
    );
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/reports/accompaniment/AccompanimentCoordinator.jsx
 **/